<template>
    <keep-alive>
        <component :is="loadPages"></component>
    </keep-alive>

    <Footer id="footer_section" class="fixed-bottom" />
</template>


<script>
    import { computed, defineAsyncComponent, onBeforeMount } from "vue";

    import { useStore } from "@/system_modules/store";
    import { useRoute } from "vue-router";

    import Footer from '@/components/footer/FooterSimple.vue';

    import { G, ajax } from "@/_common";

    export default {
        name: '404errorL',
        components: {
            Footer,
        },
        props: {
            data: {
                type: Object,
                default: () => {}
            },
        },
        setup(props) {
            const store = useStore();
            const route = useRoute();

            const def_lang = route.params && route.params.lang ? route.params.lang : "az";
            store.setLang(def_lang);

            const gpage = G.current;

            gpage.page = props.data
                ? props.data.page || G.defaultPage
                : G.defaultPage;

            onBeforeMount(async () => {
                await ajax({
                    url: store.getTranslations(),
                    success: (e) => {
                        store.setTranslations(e.data);
                    },
                });
                await ajax({
                    url: store.getSystemSettings('system'),
                    success: (x) => {
                        let res = x.data || null;
                        if ( x.status == 200 && res ) {
                            if( res.company !== undefined ){
                                for(let a in res){
                                    G.systemData[a] = {"value": res[a].value, "type": res[a].type};
                                }
                            }
                            else{
                                G.systemData = res;
                            }
                            // G.systemData = res.reduce((m, o) => m.set(o.key, o), new Map);
                            // console.log(G.systemData);
                            // console.log(res.reduce((m, o) => m.set(o.key, o), new Map)); //.values();
                            // console.log(res.reduce((m, o) => m.set(o.key, {"value": o.value, "type": o.type}), new Map)); //.values();
                        }
                    },
                });
            });

            const loadPages = computed(() => {
                return defineAsyncComponent({
                    loader: () => import(`@/${gpage.page}`).then(
                        (mod) => {
                            return mod;
                        },
                        () => {
                            return import('@/system_modules/NotFound');
                        }
                    ),
                    loadingComponent:
                            '<center><i class="fa fa-sync fa-spin"></i></center>',
                    errorComponent:
                        import('@/system_modules/NotFound'),
                        // defineAsyncComponent(() =>
                        // ),
                });
            });

            return { loadPages };
        },
    };
</script>


<style lang="scss">
    #nprogress .bar {
        height: 4px;
    }
    #nprogress .spinner {
        right: auto;
        top: 50%;
        left: 50%;
    }
    .main-content {
        width: calc(100% - 280px);
    }
    @media (max-width: 576px) {
        .main-content {
            width: 100%;
        }
    }
</style>
